import { IFormType } from "../../model/formconfiguration/FormType";
import { IFormTypeService } from "../../service/formconfiguration/FormTypeService";

export default class CopyFormTypeInteractor {
  private formTypeService: IFormTypeService;
  constructor(formTypeService) {
    this.formTypeService = formTypeService;
  }

  async execute(formTypeCode: string, newFormType: IFormType) {
    return this.formTypeService.copyFormType(formTypeCode, newFormType);
  }
}
